/** Gemeinsame Typen und Konstanten für das Travel-System. */
import { SHIP_TYPE_DEFS } from '../config/ShipTypes';

export const SHIP_COLUMNS = [
  'scout_count', 'fighter_count', 'bucaneer_count', 'battleship_count',
  'icss_count', 'carrier_count', 'receptor_count', 'colonyship_count',
] as const;

export const SHIP_NAMES = [
  'Scout', 'Fighter', 'Bucaneer', 'Battleship',
  'ICSS', 'Carrier', 'Receptor', 'Colonyship',
] as const;

export const TRAVEL_MODE_LABELS = ['Normal', 'Aufkl\u00E4rung', 'Warp'] as const;

export interface TravelLocation {
  planetId?: string | null;
  sunHexKey?: number | null;
  q: number;
  r: number;
  label: string;
  isPlanet: boolean;
  isSun: boolean;
}

export interface ActiveTravel {
  id: string;
  start: TravelLocation;
  end: TravelLocation;
  ships: number[];
  travelMode: number;
  route: { q: number; r: number }[] | null;
  totalHops: number;
  currentHop: number;
  progress: number;
  startedAt: string;
  estimatedArrivalAt: string;
  arrived: boolean;
  status: 'traveling' | 'stationed';
}

export interface OwnPlanet {
  id: string;
  label: string;
  q: number;
  r: number;
  ships: number[];
}

export interface RawTravel {
  id: string;
  start_planet_id: string | null;
  start_q: number;
  start_r: number;
  end_planet_id: string | null;
  end_sun_hex_key: number | null;
  end_q: number;
  end_r: number;
  ships: Record<string, number>;
  travel_mode: number;
  route: number[][] | null;
  total_hops: number;
  current_hop: number;
  progress: number;
  started_at: string;
  estimated_arrival_at: string;
  arrived: boolean;
  status: string;
}

/** Stationierte feindliche Schiffe auf einem Planeten. */
export interface OtherPlanetShips {
  q: number;
  r: number;
  ships: Record<string, number>;
}

/** Prüft ob die aktuelle Flotte warpen kann. */
export function computeWarpInfo(comp: number[]): { canWarp: boolean; reason: string; carrierCap: number[] } {
  const cap = [0, 0, 0, 0, 0, 0, 0, 0];
  for (let t = 0; t < 8; t++) {
    const def = SHIP_TYPE_DEFS[t];
    if (!def.warpCarry || comp[t] <= 0) continue;
    for (let s = 0; s < 8; s++) cap[s] += comp[t] * def.warpCarry[s];
  }
  for (let s = 0; s < 8; s++) {
    if (SHIP_TYPE_DEFS[s].warpCapable || comp[s] <= 0) continue;
    if (comp[s] > cap[s]) {
      const over = comp[s] - cap[s];
      return { canWarp: false, reason: `${over} ${SHIP_TYPE_DEFS[s].name} ohne Carrier-Platz`, carrierCap: cap };
    }
  }
  let total = 0;
  for (let i = 0; i < comp.length; i++) total += comp[i];
  const hasWarp = comp.some((c, i) => c > 0 && SHIP_TYPE_DEFS[i].warpCapable);
  if (!hasWarp && total > 0) return { canWarp: false, reason: 'Keine warp-f\u00E4higen Schiffe', carrierCap: cap };
  return { canWarp: true, reason: '', carrierCap: cap };
}
